module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/70a73e9b3fadba285a6d68db9a91cbb3.png";